import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateReturnFiledWithCarrier = {
  name: "updateReturnFiledWithCarrier" as const,
  input: z.object({ returnId: zExt.objectId(), filedWithCarrier: z.boolean() }),
  output: z.null(),
};
